module.exports = __webpack_public_path__ + "img/check-progress.35fcfd1c.svg";